import { infrastructureItemToJsonQueryFieldMap } from './constants/infrastructureFieldMap';
import { setTerm } from './helpers';
import { TJsonQuery } from './types';
import { EInfrastructureItem } from '../api-models/common/json_query';

const ALL_ITEMS = Object.keys(infrastructureItemToJsonQueryFieldMap).map(Number) as EInfrastructureItem[];

export function setInfrastructure(jsonQuery: TJsonQuery) {
  return (items: EInfrastructureItem[] | null): TJsonQuery => {
    const selected = new Set<EInfrastructureItem>(items ?? []);

    return ALL_ITEMS.reduce((acc, item) => {
      const field = infrastructureItemToJsonQueryFieldMap[item];

      return setTerm(field)(acc)(selected.has(item) ? true : null);
    }, jsonQuery);
  };
}
